import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box, Grid } from '@mui/material';

import {
  PageTitleAndSubTitle,
  SpecificDeductibleAnalysis,
  Table,
  Breadcrumbs,
  BasicTable,
  CardComponent,
  DashedStandardDropdown,
  NoDataVisual,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import reportMetricsMessages from '../../core-utils/messages/reportMetricsMessages';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import properties from '../../core-utils/properties';
import axios from 'axios';
import { SpecificDeductibleAnalysisData } from '../../core-utils/helper-utils/specificDeductiblehHelper';
import {
  commasForNumbers,
  numberToCurrencyFormatter,
} from '../../core-utils/helper-utils/helper';
import Loader from '../../_components/molecules/Loader';
import { useStores } from '../../stores';
import { PATIENT_DETAILS, REPORT_PLAN } from '../../core-utils/routes';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { pageScrollDown } from '../SummaryPage';
import { useEffect } from 'react';
import moment from 'moment';
import { COMMON_TEXTS } from '../../core-utils/messages/CommonConstants';
import ReportsModal from '../../_components/organisms/ReportsModal';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
// import {
//   checkUserAccess,
//   UserAccessConstants,
// } from '../../core-utils/helper-utils/userAccess';
import {
  dropDownMenuItemsValues,
  handleHeaderMouseEnter,
  handleHeaderMouseLeave,
} from '../../core-utils/helper-utils/tableSortHelper';
import NoData from '../../../public/Images/NoDataSpecificDeductible.png';
import { collapsiblePatientTableHeaderStyles } from '../../core-utils/helper-utils/riskPatientDetailsHelper';
import { CircularLoader } from '@HomaHealth/ui-component-library';
import { formatNewMembersListsData } from '../../core-utils/helper-utils/memberSummaryHelper';
import { getInfoIcon } from '../../core-utils/helper-utils/infoIconHelper';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import DateFilter from '../../_components/molecules/DateFilter';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import componentConstants from '../../core-utils/messages/componentConstants';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';

const ReportPlan = observer(() => {
  const useStyles = makeStyles()({
    mainDiv: {
      backgroundColor: '',
      border: '',
      marginTop: '40px',
      marginLeft: '63px',
    },
    flexContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '36px',
      marginBottom: '28px',
    },
    OverViewCardMargin: {
      marginRight: '24px',
    },
    GridItem: {
      marginBottom: '27px',
      display: 'inline-block',
    },
    box: {
      display: 'flex',
      flexDirection: 'row',
      boxSizing: 'border-box',
      background: 'white',
      border: '1px solid grey}',

      width: '1175px',
      height: '388px',
    },
    tableRoot: {
      padding: '0px',
    },
    tableTHForRowTop: {
      height: '48px',
      backgroundColor: patientAccessTheme.palette.grey[100],
      borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      textAlign: 'left',
      '&:first-child': {
        paddingLeft: '38px',
      },
    },
    tableRow: {
      height: '56px',
      padding: '10px',
      borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      '&:first-child': {
        paddingLeft: '32px',
      },
      '& td:first-child': {
        paddingLeft: '32px',
      },
      '& td:last-child': {
        paddingRight: '20px',
      },
      '& td': {
        paddingTop: '10px',
      },
    },
    loader: {
      minHeight: '500px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  });

  const { classes } = useStyles();
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;

  const memberSummaryStore = useStores().memberSummaryStore;
  const navigate = useNavigate();

  const location = useLocation();

  const cellStyles = {
    color: patientAccessTheme.palette.text.mediumemphasis,
    fontSize: '12px',
    fontWeight: 500,
  };

  const [noDataAvailable, setNoDataAvailable] = useState(false);
  const [dropdownValue, setDropdownValue] = React.useState('');
  const [displayValues, setDisplayValues] = useState([
    '$25,000',
    '$50,000',
    '$75,000',
    'Enter Custom Amount',
  ]);
  const [options, setOptions] = useState([
    '25000',
    '50000',
    '75000',
    'Enter Custom Amount',
  ]);
  const [
    specificDeductibleAnalysisList,
    setspecificDeductibleAnalysisList,
  ] = useState<SpecificDeductibleAnalysisData[]>();
  const [noData, setNoData] = useState<boolean>(false);
  const [submitValue, setSubmitValue] = React.useState('');
  const [selectedValue, setSelectedValue] = React.useState('');
  const [textFieldValue, setTextFieldValue] = React.useState('');
  const [isSubmitDisabled, setisSubmitDisabled] = React.useState(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalPageLoading, setTotalPageLoading] = useState<boolean>(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [columnId, setColumnId] = useState<string>();
  const [
    showSortingAndFiltering,
    setShowSortingAndFiltering,
  ] = useState<boolean>(true);
  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const [showError, setShowError] = useState<boolean>(false);
  const [membersFor50Percent, setMembersFor50Percent] = useState<any[]>([]);
  const [membersDetails, setMemberDetails] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = useState(0);

  const [totalPages, setTotalPages] = useState<number>(
    Math.ceil(membersFor50Percent?.length / 5),
  );
  const [memberDetailsLoading, setMemberDetailsLoading] = useState<boolean>(
    false,
  );
  const [clickedValue, setClickedValue] = useState<string>('');
  const screenName = allScreenLabel;
  const [aiLoading, setAiLoading] = useState<boolean>(false);

  // Edit duration related states and functions

  const employerGroupStore = useStores().employerGroupStore;
  const loginPageStore = useStores().loginPageStore;
  const recommendedTabStore = useStores().recommendedTabStore;
  const quarterlyReportStore = useStores().quaterlyReportStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quarterlyReportStore;

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const abortController = new AbortController();
  const payload = useAPIPayload();
  const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
  const [aiSummaryData, setAiSummaryData] = useState<
    { title: string; description: string }[]
  >([]);

  //snackbar
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        reportMetricsMessages.stopLossReport,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const memberColumns = [
    {
      Header: 'Category',
      id: 'category',
      Footer: 'CATEGORY',
      accessor: 'category',
      sticky: 'left',
      Cell: ({ value }: any) => (
        <>
          <div
            onClick={() => handleOnClick(value)}
            style={{ fontWeight: 500, cursor: 'pointer' }}
          >
            <Typography
              style={{
                whiteSpace: 'nowrap',
                fontSize: '12px',
                fontWeight: 500,
                lineHeight: '12px',
                color: patientAccessTheme.palette.primary[500],
                textDecoration: 'underline',
                textDecorationStyle: 'dashed',
                textDecorationThickness: '2px',
                textDecorationColor: patientAccessTheme.palette.status.icon,
                textUnderlineOffset: '4px',
              }}
            >
              {value}
            </Typography>
          </div>
        </>
      ),
    },
    {
      Header: 'Members',
      Footer: 'MEMBERS',
      accessor: 'membersCount',
      id: 'membersCount',
      sticky: 'left',
      cellType: 'none',
      icon: 'none',
      showThisColumn: true,
      DropDownMenuItems: dropDownMenuItemsValues,
    },
    {
      Header: 'Cost of Care',
      Footer: 'COST OF CARE',
      accessor: 'totalCost',
      id: 'totalCost',
      cellType: 'none',
      icon: 'none',
      showThisColumn: true,
      DropDownMenuItems: dropDownMenuItemsValues,
    },
    {
      Header: 'PMPM',
      Footer: 'PMPM',
      accessor: 'pmpm',
      id: 'pmpm',
      cellType: 'none',
      icon: 'none',
      width: '100px',
      showThisColumn: true,
      DropDownMenuItems: dropDownMenuItemsValues,
    },
  ];

  const deductibleMemberColumns: any[] = [
    {
      name: 'Member ID',
      align: 'left',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
      cellPadding: '8px 18px 8px 48px',
    },
    loginPageStore.memberIdentification && {
      name: 'Member Name',
      align: 'left',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
    },
    {
      name: 'Enrollment Status',
      align: 'left',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
    },
    {
      name: (
        <div
          style={{
            display: 'flex',
            alignItems: 'left',
            ...cellStyles,
          }}
        >
          <div>Diagnosis</div>
          <div>{getInfoIcon(`Top 3 Diagnosis based on Plan Paid`)}</div>
        </div>
      ),
      align: 'left',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
    },
    {
      name: (
        <div
          style={{
            display: 'flex',
            alignItems: 'left',
            ...cellStyles,
          }}
        >
          <div>Plan Paid</div>
        </div>
      ),
      align: 'left',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
    },
    {
      name: '% of Spec',
      align: 'left',
      cellStyles: collapsiblePatientTableHeaderStyles,
      typographyStyles: collapsiblePatientTableHeaderStyles,
      width: '',
    },
  ].filter(Boolean);

  const handleAskAi = () => {
    setActiveAskAi(true);
    getAiSummarizedData();
  };

  const getSpecificDeductibleAnalsysis = async (value: string) => {
    const baseUrl = properties.aiqBaseUrl + properties.getReportPlan;
    const requestBody = {
      incurredStartDate,
      incurredEndDate,
      paidStartDate,
      paidEndDate,
      aggregationParameter,
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
      deductible_amount: value,
      max_claim_date:
        employerGroupStore?.employerGroupResponseData?.max_claim_date,
    };
    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal })
      .then((res) => {
        if (res) {
          if (res?.data?.data && Object.entries(res.data.data).length === 0) {
            setNoDataAvailable(true);
          } else {
            setNoDataAvailable(false);
            if (
              res?.data?.data?.categories?.every(
                (item: any) => item.membersCount === 0,
              )
            ) {
              setNoData(true);
            } else {
              setNoData(false);
              const category50Data = res?.data?.data?.categories?.find(
                (item: any) => item.category === '50%',
              );
              if (category50Data) {
                setClickedValue('50%');
                setMembersFor50Percent(category50Data.members);
              }
              setspecificDeductibleAnalysisList(res?.data?.data?.categories);
            }
          }
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (membersFor50Percent.length > 0) {
      setTotalPages(Math.ceil(membersFor50Percent?.length / 5));
      setPageNumber(1);
    }
  }, [membersFor50Percent]);

  const membersRequestBody = {
    eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
    member_unique_id_list: membersFor50Percent,
    pageNumber: pageNumber - 1,
    pageSize: 5,
    deductible_amount: selectedValue,
    memberIdentification: loginPageStore.memberIdentification,
    diagnosis_count: 3,
    diagnosis_sort_field: 'totalPaid',
    diagnosis_sort_order: -1,
    max_claim_date:
      employerGroupStore?.employerGroupResponseData?.max_claim_date,
  };

  const getMemberClaims = async (memberId: string) => {
    return await axios
      .post(
        properties.aiqBaseUrl +
          properties.membersBaseUrl +
          properties.memberDetails,
        {
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
          incurredStartDate: incurredStartDate,
          incurredEndDate: incurredEndDate,
          aggregationParameter: aggregationParameter,
          paidStartDate: paidStartDate,
          paidEndDate: paidEndDate,
          member_unique_id: [memberId],
          claim_id_list: [],
          isPlanPaid: true,
        },
        { signal: abortController.signal },
      )
      .then((response) => response.data);
  };

  const deductibleMemberDetails = async () => {
    setMemberDetailsLoading(true);
    axios
      .post(
        properties.aiqBaseUrl + properties.deductiblePatientList,
        membersRequestBody,
        { signal: abortController.signal },
      )
      .then(async (res: any) => {
        if (res?.status === 200) {
          const updatedData: any[] = await Promise.all(
            res?.data?.data?.map(async (item: any) => {
              const memberClaimsData = await getMemberClaims(
                item?.member_unique_id,
              );
              return {
                ...item,
                claimData: memberClaimsData?.data,
              };
            }),
          );
          setMemberDetails(
            formatNewMembersListsData(
              updatedData,
              loginPageStore.memberIdentification,
            ),
          );
        }
        setMemberDetailsLoading(false);
      })
      .catch((error) => {
        setMemberDetailsLoading(false);
        return error;
      });
  };

  useEffect(() => {
    if (!pageNumber) {
      return;
    }
    if (membersFor50Percent.length > 0) {
      deductibleMemberDetails();
    } else {
      setMemberDetails([]);
    }
  }, [membersFor50Percent, pageNumber]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setPageNumber(value);
  };

  const getSpecificDeductibleAmount = async () => {
    const baseUrl = properties.aiqBaseUrl + properties.specificDeductible;
    const requestBody = {
      startDate:
        aggregationParameter === 'paid' ? paidStartDate : incurredStartDate,
      endDate: aggregationParameter === 'paid' ? paidEndDate : incurredEndDate,
      eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
    };
    await axios
      .post(baseUrl, requestBody, { signal: abortController.signal })
      .then((res) => {
        if (res) {
          const deductibleAmount = res?.data.data.specific_deductible;

          const isNewDeductibleUnique = !options.includes(
            deductibleAmount.toString(),
          );
          if (isNewDeductibleUnique) {
            setDisplayValues((prev) => [
              ...prev,
              `$${commasForNumbers(deductibleAmount)}`,
            ]);
            setOptions((prev) => [...prev, deductibleAmount.toString()]);
          }
          setDropdownValue(deductibleAmount);
          setisSubmitDisabled(deductibleAmount ? false : true);
        }
      })
      .catch(() => {});
  };

  const [openReportsModal, setOpenReportsModal] = useState(false);

  useEffect(() => {
    if (location.state) {
      const value: any = location.state;
      setTotalPageLoading(true);
      setDropdownValue(value.specificDeductableAmount);
      setSelectedValue(value.specificDeductableAmount);
      memberSummaryStore.setDeductibleAmount(
        Number(value.specificDeductableAmount),
      );
      handleSubmitClick();
      setTotalPageLoading(false);
    }
  }, []);

  const getAiSummarizedData = async () => {
    try {
      setAiLoading(true);

      // ✅ Clean Deductible Categories
      const cleanDeductibleData = specificDeductibleAnalysisList?.map(
        (item: any) => ({
          category: item?.category,
          membersCount: item?.membersCount,
          totalCost: item?.totalCost,
          members: item?.members,
        }),
      );

      // ✅ Clean Members Data (avoid pagination issue)
      const cleanMembersData = {
        totalMembersInBucket: membersFor50Percent?.length,
        members: membersFor50Percent,
      };

      // ✅ Optional: include current visible member details (lightweight)
      const cleanMemberDetails = membersDetails?.map((item: any) => ({
        memberId: item?.member_unique_id,
        totalCost: item?.totalCost,
        diagnoses: item?.diagnosis,
      }));

      const apiResponses = {
        title_1: cleanDeductibleData,
        title_2: cleanMembersData,
        title_3: cleanMemberDetails,
      };

      let resultArray = [];

      try {
        const response = await axios.post(
          properties.aiqBaseUrl +
            properties.contractBaseUrl +
            properties.getAiSummary,
          {
            screenName: screenName.REPORT_PLAN_50_50,
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
            incurredStartDate,
            incurredEndDate,
            paidStartDate,
            paidEndDate,
            apiData: apiResponses,
          },
        );

        // ✅ Safe extraction
        resultArray = response?.data?.data?.data?.result || [];

        setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
      } catch (apiError) {
        console.error('AI Summary API failed:', apiError);
        handleOpenSnackBar('Failed to load summary', 'warning', 4000);
        setAiSummaryData([]);
      }
    } catch (error) {
      console.error('Unexpected Error:', error);
      handleOpenSnackBar(
        'Something went wrong. Please try again.',
        'error',
        6000,
      );
      setAiSummaryData([]);
    } finally {
      setAiLoading(false);
    }
  };

  const apiCalls = async () => {
    setTotalPageLoading(true);
    isPlanDatesFetched &&
      (await Promise.all([
        submitValue === 'Clicked' ? '' : getSpecificDeductibleAmount(),
        dropdownValue !== '' && dropdownValue !== 'Enter Custom Amount'
          ? getSpecificDeductibleAnalsysis(dropdownValue)
          : textFieldValue !== ''
          ? getSpecificDeductibleAnalsysis(textFieldValue)
          : () => {},
      ]).then(() => {
        setTotalPageLoading(false);
      }));

    setTotalPageLoading(false);
  };

  const getDataForTable = () => {
    const tableSpecificAnalysisData: any[] = [];

    specificDeductibleAnalysisList?.forEach((item) => {
      const tempRowData: SpecificDeductibleAnalysisData = {
        category: '',
        membersCount: 0,
        totalCost: '',
        changePercent: 0,
        members: [],
        pmpm: '',
      };

      const categoryValueItem: string =
        item?.category + ' of $' + selectedValue + ' specific deductible';

      tempRowData.category = categoryValueItem;
      tempRowData.membersCount = item.membersCount;
      tempRowData.totalCost = numberToCurrencyFormatter(Number(item.totalCost));
      tempRowData.pmpm = numberToCurrencyFormatter(Number(item.pmpm));

      tableSpecificAnalysisData.push(tempRowData);
    });

    return tableSpecificAnalysisData;
  };

  const commonTableProps = {
    overallGridStyles: classes.tableRoot,
    classNameForTableHeaderRowTop: classes.tableTHForRowTop,
    classNameForTableHeader: classes.tableTHForRowTop,
    classNameForTableDataRow: classes.tableRow,
  };

  const handleOnClick = (value: any) => {
    const category50Data = specificDeductibleAnalysisList?.find(
      (item: any) => item.category === value.split(' ')[0],
    );
    if (category50Data) {
      setClickedValue(value.split(' ')[0]);
      setMembersFor50Percent(category50Data.members);
    }
  };

  const handleSubmitClick = async () => {
    setSubmitValue('Clicked');
    setLoading(true);
    if (dropdownValue !== '' && dropdownValue !== 'Enter Custom Amount') {
      setSelectedValue(dropdownValue);
      memberSummaryStore.setDeductibleAmount(Number(dropdownValue));
      recommendedTabStore.setSpecificDeductibleValue('');
      await getSpecificDeductibleAnalsysis(dropdownValue);
    } else if (textFieldValue !== '') {
      setSelectedValue(textFieldValue);
      memberSummaryStore.setDeductibleAmount(Number(textFieldValue));
      recommendedTabStore.setSpecificDeductibleValue(textFieldValue);
      await getSpecificDeductibleAnalsysis(textFieldValue);
    } else {
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    const customDeductableAmount = recommendedTabStore.specificDeductibleValue;
    if (customDeductableAmount !== '') {
      setTextFieldValue(customDeductableAmount);
    }
  }, []);

  useEffect(() => {
    const isTextFieldEmpty = textFieldValue === '';
    const shouldDisableSubmit = showError || isTextFieldEmpty;

    setisSubmitDisabled(shouldDisableSubmit);
  }, [showError, textFieldValue]);

  const handleCustomAmount = (event: any) => {
    if (/^$|^\d+$/.test(event.target.value)) {
      setShowError(false);
    } else {
      setShowError(true);
    }
    setTextFieldValue(event.target.value);
  };

  useEffect(() => {
    apiCalls();

    return () => {
      abortController.abort();
    };
  }, [
    isPlanDatesFetched,
    isIncurredDate,
    isPaidDate,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    aggregationParameter,
  ]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);

  const getPageTitle = () => {
    if (submitValue === 'Clicked') {
      return (
        reportMetricsMessages.pageTitles.titleAndSubtitle.title +
        ' - $' +
        commasForNumbers(selectedValue) +
        ' ' +
        reportMetricsMessages.specificDeductible.title
      );
    } else {
      return reportMetricsMessages.pageTitles.titleAndSubtitle.title;
    }
  };

  const handleSort = (event: any, column: any, item: any) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const sortColumnName = column.id;
    if (!sortColumnName) {
      return;
    }

    const newList = specificDeductibleAnalysisList
      ? [...specificDeductibleAnalysisList].sort((a: any, b: any) => {
          if (a[sortColumnName] < b[sortColumnName]) {
            return -1 * sortOrder;
          } else if (a[sortColumnName] > b[sortColumnName]) {
            return 1 * sortOrder;
          }
          return 0;
        })
      : [];

    setspecificDeductibleAnalysisList(newList);
  };

  const handleMemberClick = (value: string) => {
    if (value) {
      memberSummaryStore.setPathDetails([
        [
          'text',
          getPageTitle(),
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
        ],
      ]);
      navigate(PATIENT_DETAILS, { state: { memberId: value } });
    }
  };

  const [loader] = useState<any>(<Loader />);
  return (
    <div>
      <div className={classes.mainDiv}>
        {isPlanDatesLoading || totalPageLoading ? (
          loader
        ) : (
          <Box>
            {submitValue === 'Clicked' && (
              <Box style={{ marginBottom: '19px' }}>
                <Breadcrumbs
                  itemList={[
                    [
                      'text',
                      '50-50 Report Plan',
                      {
                        color: patientAccessTheme.palette.primary[500],
                        fontWeight: 600,
                      },
                      () => {
                        navigate(REPORT_PLAN);
                      },
                    ],
                    [
                      'text',
                      getPageTitle(),
                      {
                        color: patientAccessTheme.palette.text.highemphasis,
                        fontWeight: 600,
                      },
                    ],
                  ]}
                />
              </Box>
            )}
            <Box style={{ width: '1282px', position: 'relative' }}>
              <PageTitleAndSubTitle
                title={getPageTitle()}
                subTitle={
                  reportMetricsMessages.pageTitles.titleAndSubtitle.subTitle
                }
                subTitleMiddleString={' to '}
                subTitleStartPeriod={moment(
                  aggregationParameter === 'paid'
                    ? paidStartDate
                    : incurredStartDate,
                )?.format('MMMM YYYY')}
                subTitleEndPeriod={moment(
                  aggregationParameter === 'paid'
                    ? paidEndDate
                    : incurredEndDate,
                )?.format('MMMM YYYY')}
                showDownloadButton={submitValue === 'Clicked'}
                // downloadButtonAction={() => setOpenReportsModal(true)}
                downloadButtonAction={() => {
                  downloadPdf(
                    'stoploss5050Report',
                    {
                      employer:
                        employerGroupStore?.employerGroupResponseData
                          ?.employer_group_name,
                      member_unique_id_list: [],
                      claim_id_list: [],
                      maxClaimDate:
                        employerGroupStore?.employerGroupResponseData
                          ?.max_claim_date,
                      ...payload,
                      deductible_amount: Number(dropdownValue),
                      member_ids_crossing_50_percent_deductible: membersFor50Percent,
                    },
                    handleOpenSnackBar,
                    'open',
                  );
                  handleOpenSnackBar(
                    snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
                    'info',
                    6000,
                  );
                }}
                showQueryDataButton={
                  false
                  // checkUserAccess(
                  //   UserAccessConstants.COHORT_DETAILS,
                  //   loginPageStore.userResponse.role.name,
                  //   loginPageStore.userFeatures,
                  // )
                }
                showAskAi={submitValue === 'Clicked'}
                askAiAction={handleAskAi}
              />
              <div
                style={{
                  position: 'absolute',
                  top: '-2px',
                  left: submitValue === 'Clicked' ? '450px' : '158px',
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                }}
              >
                <Typography
                  fontSize="17px"
                  lineHeight="21px"
                  textColor={patientAccessTheme.palette.text.mediumemphasis}
                  fontType="semiBold"
                  margin="0px 8px"
                >
                  {COMMON_TEXTS.FOR}
                </Typography>
                <DateFilter />
              </div>
              <TabSelection
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={handleSelectedIndex}
                recommendationFetched={recommendationFetched}
              />
            </Box>
            {selectedTabIndex === 0 && noDataAvailable ? (
              <NoDataVisual
                height="400px"
                width="1182px"
                content={'No 50-50 report available'}
              />
            ) : submitValue === 'Clicked' ? (
              loading ? (
                loader
              ) : noData ? (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '550px',
                    width: '1086px',
                    flexDirection: 'column',
                  }}
                >
                  <div
                    style={{
                      width: '500px',
                      backgroundColor: patientAccessTheme.palette.status.error,
                      textAlign: 'center',
                    }}
                  >
                    <Typography
                      fontSize="14px"
                      fontFamily="Inter"
                      lineHeight="24px"
                      fontType="medium"
                      textColor={patientAccessTheme.palette.status.white}
                    >
                      {reportMetricsMessages.specificDeductible.noData}
                    </Typography>
                  </div>
                  <img style={{ width: '500px' }} src={NoData} />
                </div>
              ) : (
                <>
                  <Box
                    style={{
                      display: 'flex',
                      marginTop: '20px',
                      flexDirection: 'column',
                    }}
                  >
                    <Box
                      style={{
                        height: '404px',
                        width: '1176px',
                        position: 'relative',
                        background: '#FFFFFF',
                        border:
                          '1px solid' + patientAccessTheme.palette.grey[300],
                        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
                        borderRadius: '4px',
                      }}
                      sx={{
                        marginTop: '28px',
                      }}
                    >
                      <Box
                        sx={{
                          marginLeft: '24px',
                          marginTop: '20px',
                        }}
                      >
                        <Typography
                          fontSize="14px"
                          fontFamily="Inter"
                          lineHeight="24px"
                          fontType="medium"
                          textColor={
                            patientAccessTheme.palette.text.highemphasis
                          }
                          margin="0px 8px 0px 0px"
                        >
                          {reportMetricsMessages.specificDeductible.title}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          marginLeft: '24px',
                          marginTop: '4px',
                        }}
                      >
                        <Typography
                          fontSize="12px"
                          fontFamily="Inter"
                          fontType="medium"
                          lineHeight="24px"
                          textColor={
                            patientAccessTheme.palette.text.mediumemphasis
                          }
                        >
                          {reportMetricsMessages.specificDeductible.subTitle}
                        </Typography>
                      </Box>
                      <Box>
                        <Table
                          tableWrapStyles={{
                            margin: '20px 36px 0px 24px',
                          }}
                          {...commonTableProps}
                          columns={memberColumns}
                          data={getDataForTable()}
                          onHoverRowData={() => {}}
                          controlledPageIndex={0}
                          isManualPagination={true}
                          widthOfTable="1120px"
                          columnId={columnId}
                          handleMouseEnterHeader={(column: any) =>
                            handleHeaderMouseEnter(column, setColumnId)
                          }
                          handleMouseLeaveHeader={() =>
                            handleHeaderMouseLeave(setColumnId)
                          }
                          showSortingAndFiltering={showSortingAndFiltering}
                          setShowSortingAndFiltering={
                            setShowSortingAndFiltering
                          }
                          showOnHoverHeader={true}
                          handleMenuItem={handleSort}
                        />
                      </Box>
                    </Box>
                    <Grid id="member-details">
                      <CardComponent
                        title={
                          reportMetricsMessages.specificDeductible.memberDetails
                        }
                        dropdownElement={
                          <DashedStandardDropdown
                            options={
                              specificDeductibleAnalysisList?.map((item) => {
                                return (
                                  item?.category +
                                  ' of $' +
                                  selectedValue +
                                  ' specific deductible'
                                );
                              }) ?? []
                            }
                            displayValue={
                              specificDeductibleAnalysisList?.map((item) => {
                                return (
                                  item?.category +
                                  ' of $' +
                                  selectedValue +
                                  ' specific deductible'
                                );
                              }) ?? []
                            }
                            value={
                              clickedValue +
                              ' of $' +
                              selectedValue +
                              ' specific deductible'
                            }
                            handleChange={(event: any) => {
                              const category = event.target.value;
                              handleOnClick(category);
                            }}
                          />
                        }
                        subTitle={
                          reportMetricsMessages.specificDeductible
                            .memberDetailsSubtitle1 +
                          clickedValue +
                          reportMetricsMessages.specificDeductible
                            .memberDetailsSubtitle2
                        }
                        width="1182px"
                        body={
                          memberDetailsLoading ? (
                            <Grid className={classes.loader}>
                              <CircularLoader />
                            </Grid>
                          ) : (
                            <BasicTable
                              displayType="row"
                              columns={deductibleMemberColumns}
                              rowsData={membersDetails}
                              isCollapsiblePatientTable={true}
                              isFullTable
                              getMemberId={handleMemberClick}
                              headerCellHeight="46px"
                              showPagination={true}
                              pageCount={totalPages}
                              handlePagination={handlePageChange}
                              pageNumber={pageNumber}
                            />
                          )
                        }
                        padding="32px 36px 24px 24px"
                        mainGridStyles={{
                          margin: '32px 0px',
                        }}
                      />
                    </Grid>
                  </Box>
                </>
              )
            ) : (
              <Box
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  height: '388px',
                  width: '1175px',
                  position: 'relative',
                }}
              >
                <SpecificDeductibleAnalysis
                  isSubmitDisabled={isSubmitDisabled}
                  setisSubmitDisabled={setisSubmitDisabled}
                  displayValues={displayValues}
                  options={options}
                  onClick={() => {
                    handleSubmitClick();
                    setSubmitValue('Clicked');
                  }}
                  setAmount={setDropdownValue}
                  handleCustomAmount={handleCustomAmount}
                  dropDownAmount={dropdownValue}
                  customAmount={textFieldValue}
                  showError={showError}
                />
              </Box>
            )}
            {selectedTabIndex === 1 && (
              <div style={{ height: '493px', padding: '20px' }}>
                <RecommendationsTab
                  recommendationLoading={recommendationLoading}
                />
              </div>
            )}
          </Box>
        )}

        <Box id="ScrollElement"></Box>
      </div>
      {pageScrollDown('ScrollElement')}
      <AiSummaryCard
        open={activeAskAi}
        onClose={() => {
          setActiveAskAi(false);
          setAiSummaryData([]);
        }}
        aiSummaryData={aiSummaryData || []}
        loading={aiLoading}
      />
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={incurredStartDate}
        endDate={incurredEndDate}
        deductibleAmount={Number(dropdownValue)}
        members_list={membersFor50Percent}
      />
    </div>
  );
});

export default ReportPlan;
